import { ArtistConfig } from 'config';

export function filterEnabledArtists(artistIds: string[] | string): string[] {
	const enabledArtists = ArtistConfig.ENABLED_ARTISTS;
	if (!Array.isArray(artistIds)) {
		artistIds = [artistIds];
	}
	return artistIds.filter(id => enabledArtists.includes(id));
}
